import React from "react";
import { Star } from "lucide-react";
import { useContent } from "@/hooks/useContent";

const TAG_LABEL = { voyageur: "Voyageur", proprietaire: "Propriétaire" };

export const ReviewsSection = () => {
  const data = useContent("reviews", { items: [] });
  const items = (data?.items || []).filter((r) => r && r.text);
  if (!items.length) return null;

  return (
    <section className="bg-nj-olive/30 border-y border-nj-olive py-20 md:py-24" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-nj-gold text-xs tracking-[0.28em] uppercase font-semibold">Ils nous font confiance</span>
          <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-nj-text mt-3">Avis clients</h2>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-12">
          {items.map((r, i) => (
            <figure key={r.id || i} data-testid={`review-${i}`} className="bg-white border border-nj-olive rounded-md p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-3" aria-label={`${r.rating || 5} sur 5`}>
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className={`w-4 h-4 ${s < (r.rating || 5) ? "fill-nj-gold text-nj-gold" : "text-nj-olive"}`} />
                ))}
              </div>
              <blockquote className="text-nj-text2 text-sm leading-relaxed flex-1">“{r.text}”</blockquote>
              <figcaption className="mt-5 flex items-center justify-between">
                <span className="font-serif text-nj-text">{r.name || "Client"}</span>
                {r.tag && TAG_LABEL[r.tag] && (
                  <span className="text-xs uppercase tracking-wider text-nj-primary bg-nj-olive px-2.5 py-1 rounded-sm">{TAG_LABEL[r.tag]}</span>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
